(function ($, window) {
    $(document).ready(function () {
        init();
        $('body').on('cms.ready', init); // re-init after cms is ready
    });

    /**
     * Make the header dark if on page with text hero
     */
    function init() {
        var $header = $('.header');
        if ($('.text-hero').length > 0) {
            $header.addClass('header--dark');
        }
    }

})(jQuery, window);